import * as React from 'react'

import { IProductList } from 'src/models/product'
import { observer } from 'mobx-react'
import trans from '../utils/translations'

const filterOptions = [
    { id: 'default', name: 'default', dir: 'asc', label: trans.t('default') },
    { id: 'location', name: 'location', dir: 'asc', label: trans.t('locatie a - z') },
    { id: '-location', name: 'location', dir: 'desc', label: trans.t('locatie z - a') },
    { id: 'title', name: 'title', dir: 'asc', label: trans.t('naam a - z') },
    { id: '-title', name: 'title', dir: 'desc', label: trans.t('naam z - a') },
    { id: 'price', name: 'price', dir: 'asc', label: trans.t('prijs laag - hoog') },
    { id: '-price', name: 'price', dir: 'desc', label: trans.t('prijs hoog - laag') },
]

class FilterSort extends React.Component<{ productList: IProductList }, {}> {
    private changeSort(e: any) {
        const option = filterOptions.filter(fo => fo.id == e.target.value)[0]
        this.props.productList.sortBy(option.name, option.dir)
    }

    public render() {
        const { productList } = this.props
        return (
            <div className="order-holder">
                {trans.t('sorteer op')}
                <select onChange={e => this.changeSort(e)} value={productList.sort}>
                    {filterOptions.map(o => (
                        <option key={o.id} value={o.id}>
                            {o.label}
                        </option>
                    ))}
                </select>
            </div>
        )
    }
}

export default observer(FilterSort)



// WEBPACK FOOTER //
// ./react/src/components/FilterSort.tsx